export default "__VITE_ASSET__gNyFRHj6__"